export default {
  GET_PERFORMANCE_LIST: "GET_PERFORMANCE_LIST",
  GET_PERFORMANCE_VERSUS: "GET_PERFORMANCE_VERSUS",
  GET_FBDASHBOARD_LIST: "GET_FBDASHBOARD_LIST",
  GET_FBREPORT_LIST: "GET_FBREPORT_LIST",
  GET_FBGRAPH_LIST: "GET_FBGRAPH_LIST",
  GET_GDASHBOARD_LIST: "GET_GDASHBOARD_LIST",
  GET_GREPORT_LIST: "GET_GREPORT_LIST",
  GET_GGRAPH_LIST: "GET_GGRAPH_LIST",
};
